/**
 * @description
 * dispatch request headers to update detail
 *
 * @header string|internal_code
 * @header string|name
 * @header string|wh_warehouse_name
 * @header number|quantity_requested
 */
export default [
    {
        text: 'código interno',
        value: 'internal_code',
        width: '10%',
    },
    {
        text: 'nombre',
        value: 'name',
        component: {
            custom: 'id',
            type: 'link',
            props: {
                mapper: value => ({
                    name: 'product-update',
                    params: {
                        id: value,
                    },
                }),
                tooltip: 'Detalle del producto',
            },
        },
    },
    {
        text: 'solicitado',
        value: 'quantity_requested',
        format: 'number',
        align: 'right',
        width: '10%',
    },
    {
        text: 'recepcionado',
        value: 'received',
        format: 'number',
        align: 'right',
        input: {
            reverse: true,
            type: 'float-field',
        },
        width: '10%',
    },
    {
        text: 'residual a bodega',
        value: 'move_to_warehouse',
        format: 'boolean',
        align: 'center',
        input: {
            class: 'mx-auto',
            color: 'success',
            type: 'checkbox',
        },
        width: '10%',
    },
    {
        text: 'fecha',
        value: 'received_at',
        format: 'datetime',
        align: 'right',
        width: '10%',
    },
]
